module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetree-dir-expanded-6263236b114f9dccdecce424d349410f.svg";